module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"keys":{"public-key":"Chave pública","public-key-description":"Esta é sua chave para realizar testes na API. Ela não permite criar transações reais."}},"en-US":{"keys":{"public-key":"Public key","public-key-description":"This key is used for API tests. It doesn\u0027t create real transactions."}}}')
  delete Component.options._Ctor
}
